import api from "../api";
import app from "../app";
import cfg from "../cfg";
import tempus from "../tempus";
import tx from "../tx";
import vias from "./vias";


const bookingEditableStruct =  Object.freeze ({
    via_id:vias.values.PHONE,
    in_date: '',
    in_flight:'',
    in_passengers:0,
    out_date: '',
    out_flight:'',
    out_passengers:0,
    product_id:null,
    parking_id: null,
    driver:'',
    email:'',
    phone_1:'',
    phone_2:'',
    lang:'',
    car_plate:'',
    car_model:'',
    car_color:'',
    invoice_type: 10, //
    invoice_email:"",
    invoice_company:'',
    invoice_address:'',
    invoice_city:'',
    invoice_zip:'',
    invoice_nif:'',
    invoice_state:'',
    invoice_country_code:''
})

const calculatorResposeStruct =  Object.freeze ({
    num_days:0,
    availability: '?',
    total: 0
});

function getBlankBooking () {
    return { ...bookingEditableStruct,
        parking_id:app.state.parking.id,
        lang:cfg.publicDefaultLang,
    }
}

const  passengerSelectorItems = [{id:1, name:'1 passenger'}];

function generatePassengerSelectorItems() {
    let passengersTx = tx.t('passenger_s');
    passengerSelectorItems.length=0;
    passengerSelectorItems.push ({id:0, name:`0 ${passengersTx}`});
    passengerSelectorItems.push({id:1, name:"1 "+tx.t("passenger")});

    for (let i=2 ; i<=10; i++)
        passengerSelectorItems.push ({id:i, name:`${i} ${passengersTx}`});
}




function onChangeLang() {
    generatePassengerSelectorItems();
}



async function alertNotes(id) {
    let notesRespose = await api.post('booking-pro/notes', {id});
    if (notesRespose.ok) {
        let notes = '';
        if (!notesRespose?.data?.length) return;
        for(let note of notesRespose.data ) {
            notes += tempus.dateTx(note.date) + "h "+ note.user.name+"\n"+note.text+"\n\n";
        }

        alert (notes);
    }
}


async function getInvoices (bookingId) {
    let response = await api.post('booking-pro/get-invoices', {id:bookingId});
    return response.data;
}

async function payAndCreateInvoice (bookingId, paymentMethodId,fixprices) {
    return await api.post('booking-pro/pay-and-create-invoice', {id:bookingId, payment_method: paymentMethodId,fix_prices:fixprices});
}


async function convertToBooking (bookingId) {
    return await api.post('booking-pro/prebook-to-booking', {id:bookingId});
}

export default {
    onChangeLang,
    getBlankBooking,bookingEditableStruct,calculatorResposeStruct,
    getPassengerSelectorItems:()=>passengerSelectorItems,
    alertNotes,
    getInvoices,
    payAndCreateInvoice,
    convertToBooking
}

